import { ValueOfKey } from '../../utils-types';

export const TAB_VALUES = {
  WORKING_TABLE_TAB: 'WORKING_TABLE_TAB',
  FINAL_TABLE_TAB: 'FINAL_TABLE_TAB',
} as const;

export type TabValue = ValueOfKey<typeof TAB_VALUES>;
